import React, { useEffect, useRef, useState } from 'react';
import styles from './ScrollRotateImage3D.module.css';

const ScrollRotateImage3D = () => {
    const cardRef = useRef(null);
    const [rotation, setRotation] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleScroll = () => {
            if (cardRef.current) {
                const rect = cardRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Вычисляем позицию карточки относительно вьюпорта
                const cardCenter = rect.top + rect.height / 2;
                const viewportCenter = windowHeight / 2;

                // Нормализуем значение от -1 до 1
                let scrollFactor = (viewportCenter - cardCenter) / (windowHeight / 2);
                scrollFactor = Math.max(-1, Math.min(1, scrollFactor));

                // Вращение по Y от -30 до 30 градусов
                const rotateY = scrollFactor * 30;

                // Небольшое вращение по X для дополнительного эффекта
                const rotateX = scrollFactor * 10;

                setRotation({ x: rotateX, y: rotateY });

                cardRef.current.style.transform = `perspective(1500px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={styles.container}>
            <div
                ref={cardRef}
                className={styles.card}
                style={{ transform: `perspective(1500px) rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)` }}
            >
                <div className={styles.cardInner}>
                    <div className={styles.cardFront}>
                        <img
                            src="/images/tatyana-portrait.jpg"
                            alt="Татьяна Лозовская"
                            className={styles.image}
                        />
                    </div>
                    <div className={styles.cardBack}>
                        <h3>Татьяна Лозовская</h3>
                        <p>Профессиональный визажист и стилист</p>
                        <p>Опыт работы более 10 лет</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScrollRotateImage3D;